import { useTranslation } from 'react-i18next'
import { Controller, useForm } from 'react-hook-form'
import classNames from 'classnames'
import { useState } from 'react'
import Textarea from 'components/common/Textarea/Textarea'
import Button from 'components/common/Button/Button'
import Select from 'components/common/Select/Select';
import InfoMessage from 'components/common/InfoMessage/InfoMessage'
import Message from 'components/assets/icons/Message'
import Close from 'components/assets/icons/Close'
import api from 'helpers/api'
import style from './Contact.module.scss'
import commonStyle from '../../Wrapper/wrapper.module.scss'
import colors from '../../styles/colors.scss'

const ContactReporting = () => {
  const { t } = useTranslation()
  const [isSuccessMessageShown, setIsSuccessMessageShown] = useState(false)

  const {
    control,
    register,
    formState: { errors, isValid },
    handleSubmit,
    trigger,
    reset
  } = useForm({
    criteriaMode: 'all',
    mode: 'onTouched',
    delayError: 0,
    values: {
      object: '',
      message: ''
    },
  })

  const onSubmit = handleSubmit(async data => {
    try {
      const token = localStorage.getItem('reportToken');
      const response = await api.post({
        url: '/reporting/partnerMessages',
        data: data,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      console.log('Message envoyé avec succès:', response);
      setIsSuccessMessageShown(true);
      window.scrollTo(0, 0);
      reset();
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message:', error);
    }
  })

  return (
    <>
      <div className={style.main}>
        <div className={style.content}>
          <h1>{t('reporting:contact.title')}</h1>
          <p className={style.head}>{t('reporting:contact.head')}</p>
          {isSuccessMessageShown &&
            <InfoMessage
              className={style['success-message']}
              type="success"
              label={t('reporting:contact.successMessage')}
              prefix={<Message />}
              suffix={
                <div className={style.close} onClick={() => setIsSuccessMessageShown(false)}>
                  <Close styles={{ fill: '#126F0E' }} />
                </div>
              }
              style={{
                height: '20px',
                padding: '10px',
                marginTop: '30px',
                marginBottom: '30px'
              }}
            />
          }
          <form className={style.form} onSubmit={onSubmit}>
          
            <Controller
              control={control}
              name="object"
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <Select
                  error={errors.object}
                  onChange={val => {
                    onChange(val.value)
                    trigger('object')
                  }}
                  styles={{
                    control:{
                      borderRadius: '4px',
                      border: '1px solid '+colors.grey3,
                      '&:hover': {
                        border:'1px solid '+colors.grey3
                      }
                    },
                    placeholder:{
                      color: colors.grey3
                    },
                    option:{
                      color: colors.grey1
                    },
                    singleValue:{
                      color: colors.grey1
                    }
                  }}
                  options={[
                    { label: t('reporting:contact.option1'), value: t('reporting:contact.option1') },
                    { label: t('reporting:contact.option2'), value: t('reporting:contact.option2') },
                    { label: t('reporting:contact.option3'), value: t('reporting:contact.option3') },
                    { label: t('reporting:contact.option4'), value: t('reporting:contact.option4') },
                    { label: t('reporting:contact.option5'), value: t('reporting:contact.option5') },
                    { label: t('reporting:contact.option6'), value: t('reporting:contact.option6') },
                    { label: t('reporting:contact.option7'), value: t('reporting:contact.option7') },
                    { label: t('reporting:contact.option8'), value: t('reporting:contact.option8') }
                  ]}
                  placeholder={t('reporting:contact.object')}
                  value={value}
                />
              )}
            />

            <Textarea
              register={register('message', { required: true })}
              label={t('reporting:contact.message')}
              error={errors.message}
              className={classNames(commonStyle.input, style.textarea)}
            />

            <Button
              className={style.button}
              disabled={!isValid}
              label={t('reporting:contact.button')}
              onClick={handleSubmit}
            />
          </form>
        </div>
        <aside className={style.cover}></aside>
      </div>
    </>
  )
};

export default ContactReporting
